var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "app/translate/translate.service";
import { FilterFormService } from "app/views/filter_form/filter_form.service";
import { EventsService } from "app/lib/EventsService";
import { BaseComponent } from "app/views/base.component";
import { BillingService2 } from "../billing.service";
var ZeroDayComponent = /** @class */ (function (_super) {
    __extends(ZeroDayComponent, _super);
    function ZeroDayComponent(service2, activatedRoute, translate, filter, eventsService) {
        var _this = _super.call(this, eventsService, service2, activatedRoute, filter, translate) || this;
        _this.service2 = service2;
        _this.activatedRoute = activatedRoute;
        _this.translate = translate;
        _this.filter = filter;
        _this.eventsService = eventsService;
        _this.tables = {
            zero: [],
            noZero: [],
            hasRereg: [],
            noRefeg: [],
        };
        _this.statsLoader = true;
        return _this;
    }
    ZeroDayComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getList()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ZeroDayComponent.prototype.getList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, toPercent, months, tariffs, fp, stats, _loop_1, _i, months_1, month;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        toPercent = function (val) {
                            return parseFloat((val * 100).toFixed(2));
                        };
                        me.statsLoader = true;
                        months = [
                            '2016-09-01 00:00:00', '2017-09-01 00:00:00', '2018-09-01 00:00:00',
                            '2019-09-01 00:00:00',
                        ];
                        tariffs = ['month', '3months', '6months', '12months', '24months'];
                        fp = me.filter.getFilterParams();
                        return [4 /*yield*/, me.service2.zeroDay.stats(fp).toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        _loop_1 = function (month) {
                            var _loop_2 = function (tariff) {
                                var item = {
                                    type: 'data',
                                    created_month: '',
                                    month: "\u0441\u0435\u043D\u0442." + month.substring(0, 4),
                                    tariff: tariff,
                                    userCount: 0,
                                    userPaidCount: 0,
                                    userPaidCountPercent: 0,
                                    manualPaidAmount: 0,
                                    allPaidAmount: 0,
                                    LTV: 0,
                                };
                                for (var _i = 0, _a = Object.keys(me.tables); _i < _a.length; _i++) {
                                    var n = _a[_i];
                                    var row = stats[n].reduce(function (prev, curr) {
                                        if (curr.created_month === month && curr.tariffVariant === tariff) {
                                            var rowN = Object.assign({}, item);
                                            for (var _i = 0, _a = Object.keys(item); _i < _a.length; _i++) {
                                                var key = _a[_i];
                                                if (curr.hasOwnProperty(key)) {
                                                    rowN[key] = curr[key];
                                                }
                                            }
                                            rowN.userPaidCountPercent = (rowN.userCount > 0 ? toPercent(rowN.userPaidCount / rowN.userCount) : 0);
                                            return rowN;
                                        }
                                        return prev;
                                    }, item);
                                    me.tables[n].push(row);
                                }
                            };
                            for (var _i = 0, tariffs_1 = tariffs; _i < tariffs_1.length; _i++) {
                                var tariff = tariffs_1[_i];
                                _loop_2(tariff);
                            }
                            for (var _a = 0, _b = Object.keys(me.tables); _a < _b.length; _a++) {
                                var n = _b[_a];
                                var rowTotal = me.tables[n].reduce(function (prev, curr) {
                                    if (curr.created_month === month) {
                                        for (var _i = 0, _a = Object.keys(prev); _i < _a.length; _i++) {
                                            var key = _a[_i];
                                            if (curr.hasOwnProperty(key)) {
                                                prev[key] += curr[key];
                                            }
                                        }
                                    }
                                    return prev;
                                }, {
                                    userCount: 0,
                                    userPaidCount: 0,
                                    userPaidCountPercent: 0,
                                    manualPaidAmount: 0,
                                    allPaidAmount: 0,
                                    LTV: 0,
                                });
                                rowTotal.userPaidCountPercent = toPercent(rowTotal.userPaidCount / rowTotal.userCount);
                                rowTotal.LTV = rowTotal.allPaidAmount / rowTotal.userCount;
                                rowTotal = Object.assign({
                                    type: 'total',
                                    month: '',
                                    tariff: 'ВСЕГО',
                                }, rowTotal);
                                me.tables[n].push(rowTotal);
                                me.tables[n].push({
                                    type: 'space',
                                    month: '',
                                    tariff: '',
                                });
                            }
                        };
                        for (_i = 0, months_1 = months; _i < months_1.length; _i++) {
                            month = months_1[_i];
                            _loop_1(month);
                        }
                        me.statsLoader = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    return ZeroDayComponent;
}(BaseComponent));
export { ZeroDayComponent };
